import { minimizeMatrix } from "../../../../utils/minimize-matrix";
import { DataEditorMixin } from "../../../data-editor.mixin";
import { Mixins } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export class DataEditorToolMixin extends Mixins(DataEditorMixin) {
  public headers = [];

  /**
   * 获取表头数据
   */
  public getHeaders() {
    const minimizedDataInEditor = this.getMinimizedDataInEditor();
    if (minimizedDataInEditor && minimizedDataInEditor.length > 0)
      return minimizedDataInEditor[0];
    return [];
  }

  public getColHeaders() {
    const minimizedDataInEditor = this.getMinimizedDataInEditor();
    return minimizedDataInEditor.map((row) => row[0]);
  }

  /**
   * 比较传入的表头， 是否和 this.headers 相同
   */
  public compareHeaders(headers, storedHeaders = this.headers) {
    let same = true;
    if (headers.length !== storedHeaders.length) same = false;
    else {
      for (let i = 0; i < headers.length; i++) {
        if (storedHeaders[i] !== headers[i]) {
          same = false;
          break;
        }
      }
    }
    return same;
  }

  /**
   * 剔除过四边的数据
   */
  getMinimizedDataInEditor() {
    const originDataInEditor = this.getOriginDataInEditor();
    return minimizeMatrix(originDataInEditor);
  }

  /**
   * 编辑器中的原始数据
   */
  getOriginDataInEditor() {
    const { dataEditorInstance } = this;
    return dataEditorInstance.getData();
  }
}
